import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { MENU_COLORS, SIDEBAR_COLORS } from "@lhd/constants";
import { BsChatLeftDots } from "react-icons/bs";
import { MdOutlineSettingsSuggest } from "react-icons/md";

interface SidebarProps {
  isCollapse?: boolean;
  divHeight?: number;
  isMobile?: boolean;
}

export const Styles = styled.div<SidebarProps>`
  letter-spacing: 1px;
  position: fixed;
  top: ${(props) => {
    return props.isCollapse ? `${(props.divHeight ?? 52) + 48}px` : "100px";
  }};
  bottom: 0;
  left: ${(props) => (props.isMobile ? "55px" : "68px")};
  width: ${(props) => (props.isMobile ? "calc(100% - 55px)" : "240px")};
  background: #fff;
  // overflow-y: scroll;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.25);
  overscroll-behavior: contain;

  .parent-tab-1 {
    //border: 1px solid #00000026;
    display: flex;
    flex-direction: column;
    .customer-inquiry-button {
      border-bottom: 1px solid #fff;
    }
    .customer-inquiry-button.last {
      border-bottom: none;
    }
  }

  // Prevent text selection when clicking rapidly
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  .menu-text {
    height: 28px;
    border: 1px solid #1e3665;
    color: #1e3665;
    font-size: 14px;
    font-weight: 700;
    margin: ${(props) =>
      props.isMobile ? "6px 12px 6px 12px" : "6px 8px 6px 8px"};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .list-menu {
    // Add padding to items inside, not to the scrollable container
    ${(props) => props.isMobile && "padding-top: 6px;"}
    > li {
      padding: ${(props) => (props.isMobile ? "6px 12px 6px 12px" : "0 8px")};
    }
  }

  .card {
    background-color: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin: 24px;
    padding: 16px;
    width: 300px;
    transform: skew(-20deg); /* This transform skews the card */
  }

  .code {
    color: ${SIDEBAR_COLORS.TEXT_DEFAULT};
    font-weight: bold;
    font-size: 24px;
  }

  .card:before {
    content: "";
    position: absolute;
    left: -10px;
    top: 0;
    bottom: 0;
    width: 10px;
    background-color: #007bff;
  }

  .collapse-icon {
    position: fixed;
    bottom: 48px;
    color: white;
    cursor: pointer;
    width: 235px;
    text-align: right;
    background: #1f3566;
    height: 20px;
  }
  .expand-icon {
    position: fixed;
    top: 48px;
    color: white;
    cursor: pointer;
    width: 60px;
    text-align: right;
    background: #1f3566;
    height: 20px;
  }
  &.collapse {
    width: 0px !important;
    min-width: 0px !important;
    z-index: 100;
    overflow: visible !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;

    .name-company-selected,
    .list-menu,
    .wrap-footer,
    ul {
      display: none !important;
    }
  }

  .logo {
    padding: 1rem;
    font-size: 2.1rem;
    color: #fff;
    font-weight: 700;
    letter-spacing: 2px;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      &:nth-child(2) {
        color: #c9dfe1;
        font-size: 1.8rem;
        font-weight: 500;
      }
    }
  }

  ul li {
    &:last-child {
      margin-bottom: 0.3rem;
    }
  }

  li {
    font-size: 16px;

    a {
      position: relative;
      display: flex;
      align-items: center;
      padding: 0px 12px;
      width: 100%;
      font-size: 14px;
      font-weight: normal;
      height: 28px;
      line-height: 16px;
      vertical-align: middle;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT};
      box-sizing: border-box;
      // border-left: 1px solid rgba(0, 0, 0, 0.15);
      // border-right: 1px solid rgba(0, 0, 0, 0.15);

      svg,
      svg * {
        color: inherit !important;
        width: 16px !important;
        height: 16px !important;
      }

      &:hover {
        background-color: rgba(2, 20, 189, 0.08);
        color: #4759ff;
      }

      // Greyed out items
      &[data-greyed-out="true"] {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        cursor: not-allowed !important;
        border-left: none !important;

        * {
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        }

        &:hover {
          background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        }
      }
    }

    a.active {
      background: ${SIDEBAR_COLORS.CUSTOMER_BG};
      font-weight: bold;
      color: ${SIDEBAR_COLORS.TEXT_ACTIVE};
      border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE};

      span,
      svg,
      svg * {
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
      }

      &:hover {
        background: ${SIDEBAR_COLORS.CUSTOMER_BG};
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE};
      }

      &[data-greyed-out="true"] {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        border-left: none !important;

        &:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        }
      }

      &.nav-personnel-organization {
        background: #1890ff !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;

        &:hover {
          background: #40a9ff !important;
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }
      }
    }

    a.active::before {
      display: none;
    }

    a span {
      display: block;
      width: 24px;
      display: flex;
      height: 100%;
      align-items: center;
      flex-shrink: 0;
    }

    a p {
      text-align: right;
      position: absolute;
      right: 1.5rem;
      display: flex;
      align-items: center;
    }
  }
  .sidebar-sub-nav-collapse {
    margin-left: 0.5rem;

    .sub-title {
      font-size: 14px;
      font-weight: 600;
      line-height: 16px;
      vertical-align: middle;
      color: #666666;
      padding: 0.3rem 0;
      margin-bottom: 0;
      display: flex;
      align-items: center;
    }

    li {
      &:first-child {
        padding-top: 2px;
      }
    }

    a.active {
      // border-bottom: solid 1px rgba(225, 225, 225, 0.15);
      // border-top: solid 1px rgba(225, 225, 225, 0.15);
      background: rgba(225, 225, 225, 0.1);
    }
  }

  .sidebar-sub-nav {
    & > h3 {
      padding-left: 32px !important;
    }
    & > h3:first-child {
      padding-left: 0px !important;
      & a {
        padding-left: 48px !important;
      }
    }
    & > li > a {
      display: flex;
      align-items: center;
      white-space: nowrap;
      padding-left: 32px;
    }
    & > a {
      padding-left: 16px;
    }

    .sub-title {
      font-size: 14px;
      font-weight: 600;
      line-height: 16px;
      vertical-align: middle;
      color: #666666;
      padding: 0.3rem 0;
      margin-bottom: 0;
      display: flex;
      align-items: center;

      &:first-child {
        padding-top: 0;
      }
    }

    a.active {
      // border-bottom: solid 1px rgba(225, 225, 225, 0.15);
      // border-top: solid 1px rgba(225, 225, 225, 0.15);
      background: rgba(2, 20, 189, 0.06);

      &:hover {
        background: rgba(2, 20, 189, 0.1);
      }

      // Override active style for greyed out items
      &[data-greyed-out="true"],
      &.greyed-out {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        border-bottom: solid 1px ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        border-top: solid 1px ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        border-left: none !important;

        &:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
        }
      }
    }

    // Greyed out sub-nav items (for menus outside nav-group-item)
    & > li > a[data-greyed-out="true"],
    & > li > a.greyed-out {
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      cursor: not-allowed !important;
      border-bottom: solid 1px ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      border-top: solid 1px ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      border-left: none !important;

      * {
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      }

      svg,
      svg * {
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        stroke: #ffffff !important;
        fill: #ffffff !important;
      }

      &:hover {
        background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        border-bottom: solid 1px ${MENU_COLORS.DISABLED_HOVER} !important;
        border-top: solid 1px ${MENU_COLORS.DISABLED_HOVER} !important;
      }

      &.active {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        border-left: none !important;
      }

      &.active:hover {
        background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      }
    }

    & > li:last-child > a {
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
  }

  .collapse-box {
    position: absolute;
    right: -20px;
    top: 0px;
  }

  .customer-inquiry-button {
    /* Bỏ position:fixed để nằm trong flex flow của Styles */
    position: relative;
    flex-shrink: 0;
    width: 100%;
    height: 28px;
    letter-spacing: 1px;
    background-color: ${SIDEBAR_COLORS.CUSTOMER_BG};
    border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    z-index: 999;
    padding: 0px 12px;
    box-sizing: border-box;
    transition: background-color 0.2s ease;

    > div {
      font-size: 14px;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT};
      font-weight: normal;
    }

    svg,
    svg * {
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT};
      width: 16px !important;
      height: 16px !important;
    }
    &:hover:not(.greyed-out) {
      background-color: ${MENU_COLORS.NORMAL_HOVER};
    }

    &.active {
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG};
      border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE};

      > div {
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE};
        font-weight: bold;
      }

      svg,
      svg * {
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE};
      }

      // &:hover:not(.greyed-out) {
      //   background-color: ${SIDEBAR_COLORS.CUSTOMER_BG};
      // }
    }

    &.greyed-out {
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
      cursor: not-allowed !important;
      border-bottom: 1px solid #ffffff !important;
      border-left: none !important;

      > div {
        color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
      }

      * {
        color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
      }

      svg,
      svg * {
        color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
      }

      &:hover {
        background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
        color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
      }
    }

    &.collapse {
      width: 0px;
      overflow: hidden;
      padding: 0;
    }
  }

  // .customer-inquiry-button.greyed-out {
  //   background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
  //   color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
  //   cursor: not-allowed !important;
  //   pointer-events: auto;

  //   * {
  //     color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
  //   }
  //   svg,
  //   svg * {
  //     color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
  //   }
  //   &:hover {
  //     background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
  //     color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
  //   }
  // }

  .agent {
    ${(props) =>
      props.isMobile &&
      `
      background-color: #192a4d !important;
      border-left: 1px solid #ffffff !important;
      > div {
        color: #ffffff !important;
      }
      svg, svg * {
        color: #ffffff !important;
      }
      &.active {
        border-left: 4px solid #ffffff !important;
        > div {
          font-weight: bold;
        }
      }
      &.greyed-out {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        > div {
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        }
        svg, svg * {
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        }
      }
      `}
  }

  &.collapse {
    .customer-inquiry-button {
      width: 0px;
      overflow: hidden;
      padding: 0;
    }

    .wrap-footer {
      width: 0px;
      overflow: hidden;
    }
  }

  .wrap-footer {
    border-top: 1px solid #666666;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    /* Bỏ position:fixed để nằm trong flex flow */
    position: relative;
    flex-shrink: 0;
    width: 100%;
    z-index: 1000;
    background-color: #fff;
    margin-bottom: 0;
    padding-bottom: env(safe-area-inset-bottom);

    &-collapse {
      width: 80px;
      left: ${(props) => (props.isMobile ? "55px" : "68px")};
      span {
        font-size: 14px !important;
      }
    }

    &.mobile-footer {
      background-color: #192a4d;
      border-left: 1px solid #ffffff !important;
      cursor: pointer;
      justify-content: flex-start;
      padding-left: 1rem;
      span {
        color: #ffffff;
      }
      &.active {
        border-left: 4px solid #ffffff !important;
        span {
          font-weight: bold;
        }
      }
    }

    span {
      font-size: 16px;
      color: #666;
      text-align: center;
    }
  }

  .wrap-button {
    position: absolute;
    z-index: 2;
    right: 8px;
    top: 7px;
  }

  button {
    &.btn-back {
      background: #ffffff;
      border: 1px solid #174a83;
      color: #174a83;
      width: 40px;
      min-width: 40px;
    }

    &.active {
      background: ${SIDEBAR_COLORS.CUSTOMER_BG};
      color: #fff;
    }
  }

  .name-company-selected {
    height: 40px;
    border-bottom: 1px solid #ccc;
    white-space: pre-line;
    width: 80px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
    font-size: 15px;
    color: rgb(31, 54, 102);
    word-break: break-all;
    text-align: center;
  }

  // Group header styling
  .nav-group-header {
    margin: 0.5rem 0 0.3rem 0;
    padding: 0.5rem 1rem 0.3rem 1rem;
    color: ${SIDEBAR_COLORS.TEXT_DEFAULT};
    position: relative;
    .nav-group-title {
      font-size: 14px;
      padding: 8px 0px 0px 0px;
      font-weight: 600;
      line-height: 16px;
      height: 24px;
      vertical-align: middle;
      display: flex;
      align-items: center;
      color: ${SIDEBAR_COLORS.TEXT_ACTIVE};
      margin: 0;
      // Style icon ◇ larger
      &::first-letter {
        font-size: 1.3em;
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE};
      }
    }

    &.mobile {
      .nav-group-title {
        justify-content: flex-start;

        &::first-letter {
          font-size: 14px;
        }

        &::before {
          content: "";
          width: 30px;
          flex-shrink: 0;
          height: 1px;
          background-color: ${SIDEBAR_COLORS.TEXT_ACTIVE};
          margin-right: 10px;
        }

        &::after {
          content: "";
          flex: 1;
          height: 1px;
          background-color: ${SIDEBAR_COLORS.TEXT_ACTIVE};
          margin-left: 10px;
        }
      }
    }
  }

  // Group items styling
  .nav-group-item {
    margin: 0 !important;
    margin-bottom: 0 !important;
    position: relative;

    a[data-greyed-out="false"] {
      &:hover {
        background-color: ${MENU_COLORS.NORMAL_HOVER} !important;
      }
    }

    a:not(.nav-permission-management) {
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      box-sizing: border-box !important;
      font-weight: normal !important;
      line-height: 16px !important;
      border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;

      &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
        background-color: ${MENU_COLORS.NORMAL_HOVER} !important;
      }

      // Disable ::before border for all menus in group
      &.active::before {
        display: none !important;
        content: none !important;
        width: 0 !important;
        background: transparent !important;
      }

      // Greyed out items override - must be after all other styles
      &[data-greyed-out="true"] {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        cursor: not-allowed !important;
        // border-top: 1px solid ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        // border-bottom: 1px solid ${SIDEBAR_COLORS.CUSTOMER_BG} !important;

        * {
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        }

        svg,
        svg * {
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
          stroke: #ffffff !important;
          fill: #ffffff !important;
        }

        &:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
          border-top: 1px solid ${MENU_COLORS.DISABLED_HOVER} !important;
          border-bottom: 1px solid ${MENU_COLORS.DISABLED_HOVER} !important;
        }

        &.active {
          background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
          border-left: none !important;
        }

        &.active:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        }

        &::before {
          display: none !important;
        }
      }
    }

    /* Remove top border if preceded by another nav-group-item */
    .nav-group-item + & a:not(.nav-permission-management) {
      border-left: 4px solid #d9dde5 !important;
    }

    // Parent menu with sub-menu when active - only change bg, no border
    &:has(.sidebar-sub-nav) > a:not(.nav-permission-management).active {
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      font-weight: normal !important;

      span,
      svg {
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        stroke: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      }

      &:hover {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      }

      &::before {
        display: none !important;
        content: none !important;
        width: 0 !important;
        background: transparent !important;
      }

      // Override for greyed out active items
      &[data-greyed-out="true"] {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;

        &:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
        }
      }
    }

    // Single menu (no sub-menu) when active - only change bg, no border-left
    &:not(:has(.sidebar-sub-nav)) > a:not(.nav-permission-management).active {
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
      color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
      font-weight: bold !important;

      span,
      svg,
      svg * {
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
      }

      &:hover {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      }

      &::before {
        display: none !important;
        content: none !important;
        width: 0 !important;
        background: transparent !important;
      }

      // Override for greyed out active items
      &[data-greyed-out="true"] {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        border-left: none !important;

        &:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
        }
      }
    }

    .sidebar-sub-nav > li > a {
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      border-top: 1px solid transparent !important;
      border-bottom: 1px solid transparent !important;
      border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
      border-right: none !important;
      font-weight: normal !important;
      line-height: 16px !important;

      &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      }

      &.active {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
        font-weight: bold !important;

        span,
        svg,
        svg * {
          color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
        }

        &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
          background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        }
      }

      // Greyed out sub-nav items
      &[data-greyed-out="true"],
      &.greyed-out {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        cursor: not-allowed !important;
        border-top: 1px solid ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        border-bottom: 1px solid ${SIDEBAR_COLORS.CUSTOMER_BG} !important;

        * {
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        }

        svg,
        svg * {
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
          stroke: #ffffff !important;
          fill: #ffffff !important;
        }

        &:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
          border-top: 1px solid ${MENU_COLORS.DISABLED_HOVER} !important;
          border-bottom: 1px solid ${MENU_COLORS.DISABLED_HOVER} !important;
        }

        &.active {
          background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
          border-left: none !important;
        }

        &.active:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
          color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;
        }
      }
    }

    // Overlay for locked core-app group items
    &.nav-group-core-app-locked {
      position: relative;
      overflow: hidden; // Prevent overlay from spilling out

      // Overlay to block interactions - semi-transparent but still visible
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 8px; // Account for li padding
        right: 8px; // Account for li padding
        bottom: 0;
        background-color: rgba(250, 250, 250, 0.7); // Semi-transparent overlay
        z-index: 100;
        pointer-events: all;
        cursor: not-allowed;
      }

      // Disable all interactions but keep content visible
      a,
      .sidebar-sub-nav,
      .sidebar-sub-nav > li,
      .sidebar-sub-nav > li > a,
      .sidebar-sub-nav > li > a * {
        pointer-events: none !important;
        cursor: not-allowed !important;
      }
    }

    .sidebar-sub-nav {
      margin: 0 !important;
      margin-top: 0 !important;
      padding: ${(props) =>
        props.isMobile ? "6px 0 0 0 !important" : "0 !important"};
      background-color: transparent;

      & > li {
        margin: 0 !important;
        padding: ${(props) =>
          props.isMobile ? "6px 0 !important" : "0 !important"};

        & > a {
          display: flex;
          align-items: center;
          white-space: nowrap;
          padding-left: 32px;
          padding-top: 0.3rem;
          padding-bottom: 0.3rem;
          margin: 0 !important;
          background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          // border-top: 1px solid #ffffff !important;
          // border-bottom: 1px solid #ffffff !important;
          // border-left: none !important;
          // border-right: none !important;
          border-radius: 0 !important;
          font-weight: normal !important;
          line-height: 16px !important;

          &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          }

          &.active {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
            color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
            font-weight: bold !important;

            &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
              background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            }
          }
        }
      }
    }

    &:not(.nav-group-item + .nav-group-item) {
      a:not(.nav-permission-management) {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }

      // Override for parent menu with sub-menu when active
      &:has(.sidebar-sub-nav) a:not(.nav-permission-management).active {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        font-weight: normal !important;

        span,
        svg {
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          stroke: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }
      }

      // Override for single menu when active
      &:not(:has(.sidebar-sub-nav)) a:not(.nav-permission-management).active {
        border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
        font-weight: bold !important;
      }

      &:has(.sidebar-sub-nav) {
        a:not(.nav-permission-management) {
          border-bottom: none !important;
        }

        .sidebar-sub-nav > li > a {
          border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
          border-radius: 0 !important;

          &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          }

          &.active {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
            border-right: 1px solid transparent !important;
            border-top: 1px solid transparent !important;
            border-bottom: 1px solid transparent !important;
            color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
            font-weight: bold !important;

            &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
              background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            }
          }
        }
      }
    }

    a:not(.nav-permission-management) {
      border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
    }

    & + .nav-group-item {
      a:not(.nav-permission-management) {
        border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
      }

      // Override for parent menu with sub-menu when active
      &:has(.sidebar-sub-nav) a:not(.nav-permission-management).active {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        font-weight: normal !important;

        span,
        svg {
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          stroke: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }
      }

      // Override for single menu when active
      &:not(:has(.sidebar-sub-nav)) a:not(.nav-permission-management).active {
        border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
        font-weight: bold !important;
      }

      &:has(.sidebar-sub-nav) {
        a:not(.nav-permission-management) {
          border-bottom: none !important;
        }

        .sidebar-sub-nav > li > a {
          border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
          border-radius: 0 !important;

          &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          }

          &.active {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
            color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
            font-weight: bold !important;

            &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
              background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            }
          }
        }
      }
    }

    &:not(:has(+ .nav-group-item)) {
      a:not(.nav-permission-management) {
        border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
      }

      // Override for parent menu with sub-menu when active
      &:has(.sidebar-sub-nav) a:not(.nav-permission-management).active {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        font-weight: normal !important;

        span,
        svg {
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          stroke: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }
      }

      // Override for single menu when active
      &:not(:has(.sidebar-sub-nav)) a:not(.nav-permission-management).active {
        border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
        font-weight: bold !important;
      }

      &:has(.sidebar-sub-nav) {
        a:not(.nav-permission-management) {
          border-bottom: none !important;
        }

        .sidebar-sub-nav > li > a {
          border-top: 1px solid #ffffff !important;
          border-bottom: 1px solid #ffffff !important;
          border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
          border-right: 1px solid #00000026 !important;
          border-radius: 0 !important;

          &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          }

          &.active {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
            border-right: 1px solid transparent !important;
            border-top: 1px solid transparent !important;
            border-bottom: 1px solid transparent !important;
            color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
            font-weight: bold !important;

            &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
              background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            }
          }
        }

        .sidebar-sub-nav > li:last-child > a {
          border-top: 1px solid #ffffff !important;
          border-bottom: 1px solid #00000026 !important;
          border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
          border-right: 1px solid #00000026 !important;
          border-bottom-left-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
          border-top-left-radius: 0 !important;
          border-top-right-radius: 0 !important;

          &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          }

          &.active {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
            border-right: 1px solid transparent !important;
            border-top: 1px solid transparent !important;
            border-bottom: 1px solid transparent !important;
            color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
            font-weight: bold !important;

            &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
              background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            }
          }
        }
      }

      &:not(:has(.sidebar-sub-nav)) {
        a:not(.nav-permission-management) {
          border-bottom-left-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }
      }
    }

    &:last-of-type:not(.nav-group-item + .nav-group-item) {
      a:not(.nav-permission-management) {
        border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
      }

      // Override for parent menu with sub-menu when active
      &:has(.sidebar-sub-nav) a:not(.nav-permission-management).active {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        font-weight: normal !important;

        span,
        svg {
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          stroke: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }
      }

      // Override for single menu when active
      &:not(:has(.sidebar-sub-nav)) a:not(.nav-permission-management).active {
        border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
        font-weight: bold !important;
      }

      &:has(.sidebar-sub-nav) {
        a:not(.nav-permission-management) {
          border-bottom: none !important;
        }

        .sidebar-sub-nav > li > a {
          border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
          border-radius: 0 !important;

          &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          }

          &.active {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
            color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
            font-weight: bold !important;

            &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
              background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            }
          }
        }

        .sidebar-sub-nav > li:last-child > a {
          border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
          border-bottom-left-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
          border-top-left-radius: 0 !important;
          border-top-right-radius: 0 !important;

          &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          }

          &.active {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
            color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
            font-weight: bold !important;

            &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
              background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            }
          }
        }
      }

      &:not(:has(.sidebar-sub-nav)) {
        a:not(.nav-permission-management) {
          border-bottom-left-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }
      }
    }

    &:only-child {
      a:not(.nav-permission-management) {
        border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
        border-radius: 8px;
      }

      // Override for parent menu with sub-menu when active
      &:has(.sidebar-sub-nav) a:not(.nav-permission-management).active {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        font-weight: normal !important;

        span,
        svg {
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          stroke: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }
      }

      // Override for single menu when active
      &:not(:has(.sidebar-sub-nav)) a:not(.nav-permission-management).active {
        border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
        font-weight: bold !important;
      }

      &:has(.sidebar-sub-nav) {
        a:not(.nav-permission-management) {
          border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
          border-bottom: none !important;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        }

        .sidebar-sub-nav > li > a {
          border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
          border-radius: 0 !important;

          &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          }

          &.active {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
            color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
            font-weight: bold !important;

            &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
              background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            }
          }
        }

        .sidebar-sub-nav > li:last-child > a {
          border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
          border-bottom-left-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
          border-top-left-radius: 0 !important;
          border-top-right-radius: 0 !important;

          &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          }

          &.active {
            background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;
            color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
            font-weight: bold !important;

            &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
              background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
            }
          }
        }
      }
    }
  }

  li:has(a.nav-permission-management) {
    margin-bottom: 0;

    a.nav-permission-management {
      margin: 6px 0 !important;
      font-weight: normal;
      padding: 0 12px !important;
      padding-left: 8px !important;
      letter-spacing: 1px;
      padding-right: 12px !important;
      height: 32px !important;
      line-height: 16px !important;
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      border: none !important;
      border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
      border-radius: 0 !important;
      cursor: pointer !important;

      // Disable ::before border for this menu
      &::before {
        display: none !important;
        content: none !important;
        width: 0 !important;
        background: transparent !important;
      }

      span,
      svg {
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        stroke: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      }

      &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      }

      // Menu cha không có style active - chỉ là toggle
      &.active {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        font-weight: normal !important;
        border: none !important;
        border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;

        span,
        svg {
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          stroke: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          fill: transparent !important;
        }
        svg * {
          stroke: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }

        &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
          background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        }

        &::before {
          display: none !important;
          content: none !important;
          width: 0 !important;
          background: transparent !important;
        }
      }

      // Greyed out state for nav-permission-management
      &[data-greyed-out="true"] {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        cursor: not-allowed !important;
        border-left: none !important;

        * {
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }

        span,
        svg {
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          stroke: #ffffff !important;
          fill: #ffffff !important;
        }

        &:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }

        &.active {
          background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          color: ${MENU_COLORS.TEXT_WHITE} !important;
        }
      }
    }

    .sidebar-sub-nav > li > a {
      display: flex;
      align-items: center;
      white-space: nowrap;
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      color: ${MENU_COLORS.TEXT_NAVY} !important;
      border: none !important;
      margin: 0 !important;
      font-weight: normal !important;
      line-height: 16px !important;

      &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      }

      &.active {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        border-left: none !important;
        color: ${MENU_COLORS.TEXT_WHITE} !important;
        border-right: none !important;
        border-top: none !important;
        border-bottom: none !important;

        &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
          background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        }

        &::before {
          display: none !important;
          content: none !important;
          width: 0 !important;
          background: transparent !important;
        }
      }

      // Greyed out override for nav-permission-management submenu
      &[data-greyed-out="true"],
      &.greyed-out {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        cursor: not-allowed !important;
        border: none !important;
        border-left: none !important;

        * {
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }

        svg,
        svg * {
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          stroke: #ffffff !important;
          fill: #ffffff !important;
        }

        &:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }

        &.active {
          background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          border-left: none !important;
          border-right: none !important;
          border-top: none !important;
          border-bottom: none !important;
        }

        &.active:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }
      }
    }

    &:has(.sidebar-sub-nav) {
      a.nav-permission-management {
        border-radius: 0 !important;
        margin-bottom: 0 !important;
      }

      .sidebar-sub-nav {
        margin: 0 !important;
        margin-bottom: 2px !important;
        padding: 0 !important;
        background-color: transparent;

        & > li {
          margin: 0 !important;

          & > a {
            display: flex;
            align-items: center;
            white-space: nowrap;
            padding-left: 32px;
            padding-top: 0.3rem;
          }

          &:last-child > a {
            border-bottom-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
          }
        }
      }
    }
  }

  li:has(a.nav-single-tab) {
    margin-bottom: 0;

    a.nav-single-tab:not([data-greyed-out="true"]) {
      margin: 6px 0 !important;
      font-weight: normal;
      padding: 0 12px !important;
      padding-left: 8px !important;
      padding-right: 12px !important;
      height: 28px !important;
      letter-spacing: 1px;
      line-height: 16px !important;
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      border: none !important;
      border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
      border-radius: 0 !important;
      cursor: pointer !important;

      &:hover {
        background-color: ${MENU_COLORS.NORMAL_HOVER} !important;
      }

      &.active {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_ACTIVE} !important;
        font-weight: bold !important;
        border: none !important;
        border-left: 4px solid ${SIDEBAR_COLORS.BORDER_ACTIVE} !important;

        span,
        svg {
          color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
          stroke: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        }

        &:hover:not([data-greyed-out="true"]):not(.greyed-out) {
          background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        }

        &::before {
          display: none !important;
          content: none !important;
          width: 0 !important;
          background: transparent !important;
        }
      }
    }

    a.nav-single-tab[data-greyed-out="true"],
    a.nav-single-tab.greyed-out {
      margin: 6px 0 !important;
      font-weight: normal;
      padding: 0 12px !important;
      padding-left: 8px !important;
      padding-right: 12px !important;
      height: 28px !important;
      letter-spacing: 1px;
      line-height: 16px !important;
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      border: none !important;
      border-left: none !important;
      border-radius: 0 !important;
      cursor: not-allowed !important;

      span,
      svg,
      svg * {
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        stroke: #ffffff !important;
        fill: #ffffff !important;
      }

      &:hover {
        background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      }

      &.active {
        background-color: ${MENU_COLORS.DISABLED} !important;
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      }

      &.active:hover {
        background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
      }

      &::before {
        display: none !important;
        content: none !important;
        width: 0 !important;
        background: transparent !important;
      }
    }
  }

  &&&&&&&& {
    a[data-greyed-out="true"],
    li[data-greyed-out="true"] a,
    [data-greyed-out="true"] a,
    .greyed-out,
    a.greyed-out,
    li.greyed-out a,
    .greyed-out a {
      border-left: none !important;
    }
  }
`;

interface CompanyNameWrapperProps {
  $isTwoLines?: boolean;
}

export const CompanyNameWrapper = styled.div<CompanyNameWrapperProps>`
  font-weight: normal;
  padding: 0 5px;
  padding-right: 50px !important;
  font-size: ${(props) => (props.$isTwoLines ? "12px" : "15px")};
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  color: #ffffff;
  background: #192a4d;
  cursor: pointer;
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  height: 60px;
  box-sizing: border-box;
`;

interface NameCompanySelectedProps {
  $isTwoLines?: boolean;
  $isOverNameCompany?: boolean;
}

export const NameCompanySelected = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith("$"),
})<NameCompanySelectedProps>`
  height: 40px;
  border-bottom: 1px solid #ccc;
  white-space: pre-line;
  width: 80px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.$isOverNameCompany ? "flex-start" : "center"};
  font-weight: normal;
  font-size: ${(props) => (props.$isTwoLines ? "12px" : "15px")};
  padding: ${(props) => (props.$isTwoLines ? "8px 5px" : "10px 5px")};
  color: rgb(31, 54, 102);
  word-break: break-all;
  text-align: center;
`;

interface ListMenuProps {
  isCollapse?: boolean;
  maintenanceBannerHeight?: number;
  isMobile?: boolean;
}

export const ListMenu = styled.ul<ListMenuProps>`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 25px; /* Tăng padding bottom một chút để cuộn thoáng hơn trên mobile */
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 0;
  min-height: 0;
  max-height: ${(props) => {
    const offset =
      (props.isCollapse ? 136 : 104) +
      (props.isMobile ? 7 : 103) +
      (props.maintenanceBannerHeight || 0);
    return `calc(100vh - ${offset}px)`;
  }};
  /* iOS smooth momentum scroll */
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-track {
    background: #c8c8c8;
  }
  list-style: none;
  li {
    list-style: none;
  }
  .parent-tab {
    //border: 1px solid #00000026;
    margin: 0px 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;

    &-only {
      border: none;
      margin: 0px 10px;
    }
  }

  a[data-testid="nav-business-rpg"] {
    letter-spacing: normal;
  }

  .nav-group-item {
    &:has(.sidebar-sub-nav) > a:not(.nav-permission-management).active {
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      border-left: 4px solid ${SIDEBAR_COLORS.CUSTOMER_BORDER} !important;
      border-right: 1px solid rgba(0, 0, 0, 0.15) !important;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      font-weight: normal !important;

      span,
      svg {
        color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
        stroke: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      }

      &:hover {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      }

      &::before {
        display: none !important;
        content: none !important;
        width: 0 !important;
        background: transparent !important;
      }

      // Override for greyed out active items
      &[data-greyed-out="true"] {
        background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
        color: ${SIDEBAR_COLORS.TEXT_DISABLED} !important;

        &:hover {
          background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
        }
      }
    }
  }
`;

interface SidebarStyleProps {
  isOpenByHover?: boolean;
  isCollapse?: boolean;
  divHeight?: number;
  maintenanceBannerHeight?: number;
}

export const SidebarContainer = styled.div<SidebarStyleProps>`
  z-index: ${(props) => (props.isOpenByHover ? 101 : 9)};
  top: ${(props) => {
    const baseTop = props.isCollapse ? props.divHeight! + 48 : 48;
    return `${baseTop + (props.maintenanceBannerHeight || 0)}px`;
  }};
`;

interface MenuItemLinkProps {
  marginBottom?: string;
  isGreyedOut?: boolean;
}

export const MenuItemLink = styled.a<MenuItemLinkProps>`
  margin-bottom: ${(props) => props.marginBottom || "0"};
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  vertical-align: middle;
  ${(props) =>
    props.isGreyedOut &&
    `
    background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
    color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
    cursor: not-allowed !important;
    
    &:hover {
      background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
      color: #FFFFFF !important;
    }
    
    &.active {
      background-color: #D9D9D9 !important;
      color: #FFFFFF !important;
    }
    
    &.active:hover {
      background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
      color: #FFFFFF !important;
    }
    
    * {
      color: #FFFFFF !important;
    }
    
    /* Allow chevron icon to be clickable and show pointer cursor */
    p {
      cursor: pointer !important;
      
      &:hover {
        opacity: 0.9;
      }
      
      svg {
        transition: opacity 0.2s;
      }
    }
  `}
`;

export const MenuItemContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const MenuItemTitle = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  white-space: nowrap;
  min-width: 0;
`;

interface SubNavLinkProps {
  marginBottom?: string;
  isGreyedOut?: boolean;
}

export const SubNavLink = styled(NavLink)<SubNavLinkProps>`
  margin-bottom: ${(props) => props.marginBottom || "0"};
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  vertical-align: middle;
  ${(props) =>
    props.isGreyedOut &&
    `
    background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
    color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
    cursor: not-allowed !important;
    
    * {
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
    }
    
    svg,
    svg * {
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      stroke: #ffffff !important;
      fill: #ffffff !important;
    }
    
    &:hover {
      background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
    }
    
    &.active {
      background-color: ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      border-left: none !important;
      border-bottom: solid 1px ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
      border-top: solid 1px ${SIDEBAR_COLORS.CUSTOMER_BG} !important;
    }

    &.active:hover {
      background-color: ${MENU_COLORS.DISABLED_HOVER} !important;
      color: ${SIDEBAR_COLORS.TEXT_DEFAULT} !important;
      border-bottom: solid 1px ${MENU_COLORS.DISABLED_HOVER} !important;
      border-top: solid 1px ${MENU_COLORS.DISABLED_HOVER} !important;
    }
  `}
`;

export const SubNavSpan = styled.span`
  width: 100%;
  letter-spacing: 10px;
`;

export const CustomerInquiryIconWrapper = styled.span<SidebarStyleProps>`
  display: ${(props) => (props.isCollapse ? "none" : "flex")};
  align-items: center;
  width: 24px;
`;

export const CustomerInquiryIcon = styled(BsChatLeftDots).attrs({
  size: 20,
})`
  color: ${MENU_COLORS.TEXT_WHITE};
`;

export const OperationIconWrapper = styled.span<SidebarStyleProps>`
  display: ${(props) => (props.isCollapse ? "none" : "flex")};
  align-items: center;
  width: 24px;
`;

export const OperationIcon = styled(MdOutlineSettingsSuggest).attrs({
  size: 20,
})`
  * {
    fill: currentColor !important;
  }
  path[fill="none"] {
    fill: transparent !important;
  }
`;

export const CustomerInquiryTextWrapper = styled.div<{ $disabled?: boolean }>`
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 0;
  color: ${({ $disabled }) => ($disabled ? "#9ca3af" : "#333333")} !important;
`;
export const CustomerAgentTextWrapper = styled.div<{ $disabled?: boolean }>`
  height: 100%;
  display: flex;
  align-items: center;
  color: ${({ $disabled }) => ($disabled ? "#9ca3af" : "#333333")} !important;
`;
